import HTTP from "../ajax";
import { apiEndpoints as ApiEndpoints, site, mid } from "../apiEndpoints";
import Utility from "../../helpers/paymentHelpers/utility";
import localStorageFunc from "../../helpers/paymentHelpers/localStorageFunc";

const GET_PWA_CONFIG = async ({ headers, payload }) => {
  return HTTP.get(ApiEndpoints.PWA_CONFIG_API, { headers: headers }).catch(
    (err) => {
      return err;
    }
  );
};

const GET_APP_CONFIG = async ({ headers, payload }) => {
  return HTTP.get(ApiEndpoints.APP_CONFIG_API, { headers: headers }).catch(
    (err) => {
      return err;
    }
  );
};

const RECOMMENDED_PAYMENT_OPTION_API = async ({ headers, payload }) => {
  let endPoint = `${ApiEndpoints.RECOMMENDED_PAYMENT_OPTION}?order_for_someOneElse=${payload?.orderForSomeoneElse}`;
  if (payload["visible_count"])
    endPoint = endPoint + "&visible_count=" + payload["visible_count"];
  return HTTP.get(endPoint, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const OTHER_PAYMENT_OPTION_API = async ({ headers, payload }) => {
  return HTTP.get(ApiEndpoints.OTHER_PAYMENT_OPTION, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const GET_SAVED_CARDS_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.GET_SAVED_CARDS}${
      payload.PROMOCODE
        ? `?appliedPromo=${payload.PROMOCODE}`
        : "?promoOffers=true"
    }`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const PAYTM_WALLET_BALANCE_API = async ({ headers, payload }) => {
  let custmHeader = {
    ...headers,
    mid: mid,
    "X-TenantID": "dominos_IN",
    channel: "PWA",
    instrument: "PPI",
  };
  return HTTP.post(`${ApiEndpoints.GET_PAYTM_WALLET_BALANCE}`, payload, {
    headers: custmHeader,
  }).catch((err) => {
    return err;
  });
};

const PAYTM_OTP_API = async ({ headers, payload }) => {
  return HTTP.post(ApiEndpoints.GET_PAYTMFORM_OTP, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const GET_CHARGE_API = async ({ headers, payload }) => {
  return HTTP.post(ApiEndpoints.GET_CHARGE_DATA, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const PAYTM_OTP_SUBMIT_API = async ({ headers, payload }) => {
  return HTTP.post(ApiEndpoints.PAYTMOTP_VERIFY, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const PAYMENT_SUBMIT_ORDER_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.SUBMIT_ORDER}/${payload.query.urlParam.$transactionId}`,
    payload.data,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const GET_TRANSACTION_STATUS_API = async ({ headers, payload, CUSTOM_URL }) => {
  return HTTP.post(CUSTOM_URL, payload, {
    headers: { "content-type": "application/json;charset=UTF-8" },
  }).catch((err) => {
    return err;
  });
};

const POST_SUBMIT_ORDER_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.POST_SUBMIT_ORDER}?userId=${payload.urlParam.userId}&site=${site}`,
    payload.data,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const PROCESS_TRANSACTION_API = async ({ headers, payload, url }) => {
  let custmUrl = `https://securegw.paytm.in/theia/api/v1/processTransaction?mid=${payload?.body?.mid}&orderId=${payload?.body?.orderId}`;
  if (url) {
    custmUrl = url;
  }
  return HTTP.post(custmUrl, payload, {
    headers: { "content-type": "application/json;charset=UTF-8" },
  }).catch((err) => {
    return err;
  });
};

const PAYTM_WALLET_REDEEM_API = async ({ headers, payload }) => {
  return HTTP.put(ApiEndpoints.PAYTM_SUBMIT_ORDER, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const ANONYNMOUS_USER_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.ANONYMOUS_USER}?v=${Utility.randomnumber()}`,
    payload,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const PROCESS_PAYMENT_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.PROCESS_PAYMENT}/submit?processDirect=${true}`,
    payload,
    {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    }
  ).catch((err) => {
    return err;
  });
};

const GET_COD_OTP = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.GET_COD_OTP}/${payload.orderTransactionId}/otp`,
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const GIFT_EVOUCHER_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.SUBMIT_ORDER}/${payload.orderTransactionId}`,
    payload,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const GIFTCARD_OTP_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.GET_VOUCHER_OTP}${payload}/reset_pin`,
    {},
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const ADVANCE_ORDER_TIME_API = async ({ headers, payload }) => {
  let dType = localStorageFunc.getDeliveryType();
  if (dType == "D") {
    return HTTP.post(
      `${ApiEndpoints.ADVANCE_TIME_ORDER}/advanceorder-time`,
      payload,
      {
        headers: headers,
      }
    ).catch((err) => {
      return err;
    });
  } else {
    return HTTP.get(
      `${ApiEndpoints.ADVANCE_TIME_ORDER}/${JSON.parse(
        JSON.stringify(payload)
      )}?timeSlots=true`,
      {
        headers: headers,
      }
    ).catch((err) => {
      return err;
    });
  }
};

const REMOVE_CART_PROMO = async ({ headers, payload }) => {
  return HTTP.delete(
    `${ApiEndpoints.CART_REMOVE_PROMO}/${payload.cartId}/promo/${
      payload.promoCode
    }?includePartnerOffer=${!payload.isMiniApp}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const APPLY_CART_PROMO = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.CART_REMOVE_PROMO}/${payload.cartId}/promo/${
      payload.promoCode
    }?includePartnerOffer=${!payload.isMiniApp}`,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const BIN_DISCOUNT_CARD_VALIDATOR = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.BIN_DISCOUNT_CARD_CHECKER}/${payload.cartId}/bin/${payload.cardNumber}`,
    { headers: headers }
  ).catch((err) => {
    return err;
  });
};

const RESEND_RAZORPAY_OTP = async ({ headers, payload }) => {
  return HTTP.post(payload.endPoint, {}, { headers: headers }).catch((err) => {
    return err;
  });
};

const SUBMIT_RAZORPAY_OTP = async ({ headers, payload }) => {
  return HTTP.post(payload.endPoint, payload.data, { headers: headers }).catch(
    (err) => {
      return err;
    }
  );
};

const RAZORPAY_PAYMENT_STATUS = async ({ headers, payload }) => {
  return HTTP.post(ApiEndpoints.PAYMENT_STATUS, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const GET_CART_DATA_API = async ({ headers, payload }) => {
  return HTTP.put(
    `${ApiEndpoints.PUT_CART_ITEMS}/${payload.cartId}/items`,
    payload.queryObj,
    {
      headers: headers,
    }
  ).catch((err) => {
    return err;
  });
};

const GET_INITIAL_CART = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.GET_INITIAL_CART}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const GET_COLLECT_UPI_STATUS_API = async ({ headers, payload, url }) => {
  return HTTP.get(url, { headers: headers }).catch((err) => {
    return err;
  });
};

const RESEND_UNIFIED_OTP = async ({ headers, payload }) => {
  return HTTP.post(payload.endPoint, {}, { headers: headers }).catch((err) => {
    return err;
  });
};

const SUBMIT_UNIFIED_OTP = async ({ headers, payload }) => {
  return HTTP.post(payload.endPoint, payload.data, { headers: headers }).catch(
    (err) => {
      return err;
    }
  );
};

const GET_SENTINELIZED_API = async ({ headers, payload }) => {
  return HTTP.post(ApiEndpoints.GET_SENTINELIZED_API, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

export default {
  GET_PWA_CONFIG,
  GET_APP_CONFIG,
  RECOMMENDED_PAYMENT_OPTION_API,
  OTHER_PAYMENT_OPTION_API,
  PAYTM_WALLET_BALANCE_API,
  GET_SAVED_CARDS_API,
  PAYTM_OTP_API,
  PAYTM_OTP_SUBMIT_API,
  POST_SUBMIT_ORDER_API,
  PAYTM_WALLET_REDEEM_API,
  GET_CHARGE_API,
  GET_TRANSACTION_STATUS_API,
  PROCESS_TRANSACTION_API,
  ANONYNMOUS_USER_API,
  PROCESS_PAYMENT_API,
  GET_COD_OTP,
  GIFT_EVOUCHER_API,
  PAYMENT_SUBMIT_ORDER_API,
  GIFTCARD_OTP_API,
  ADVANCE_ORDER_TIME_API,
  APPLY_CART_PROMO,
  REMOVE_CART_PROMO,
  BIN_DISCOUNT_CARD_VALIDATOR,
  RESEND_RAZORPAY_OTP,
  SUBMIT_RAZORPAY_OTP,
  RAZORPAY_PAYMENT_STATUS,
  GET_CART_DATA_API,
  GET_INITIAL_CART,
  GET_COLLECT_UPI_STATUS_API,
  RESEND_UNIFIED_OTP,
  SUBMIT_UNIFIED_OTP,
  GET_SENTINELIZED_API,
};
